import React from 'react';
import { useTranslation } from 'react-i18next';
import './CookieConsentBanner.css';

export const CONSENT_KEY = 'glowapp_analytics_consent';

export function getConsent() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(CONSENT_KEY, value);
  } catch (_) {}
}

const CookieConsentBanner = ({ onAccept, onReject }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = React.useState(() => !getConsent());

  const handleAccept = () => {
    setConsent('granted');
    setVisible(false);
    onAccept?.();
  };

  const handleReject = () => {
    setConsent('denied');
    setVisible(false);
    onReject?.();
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-banner" role="dialog" aria-label={t('cookieConsentTitle', 'Cookie consent')}>
      <div className="cookie-consent-content">
        <p className="cookie-consent-text">
          {t('cookieConsentMessage', 'We use cookies and analytics to improve the site. You can accept or reject non-essential cookies.')}
        </p>
        <div className="cookie-consent-buttons">
          <button type="button" className="cookie-consent-btn cookie-consent-accept" onClick={handleAccept}>
            {t('cookieConsentAccept', 'Accept')}
          </button>
          <button type="button" className="cookie-consent-btn cookie-consent-reject" onClick={handleReject}>
            {t('cookieConsentReject', 'Reject')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
